import { Component, type ReactNode, type ErrorInfo } from 'react';
import i18n from '@/i18n';
import { ErrorPage } from '@/shared/components/ErrorPage';
import { reportError } from '@/lib/error-reporter';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Unhandled app error:', error, errorInfo);
    reportError(error, 'AppErrorBoundary');
  }

  handleReload = (): void => {
    window.location.reload();
  };

  override render(): ReactNode {
    if (this.state.hasError) {
      return (
        <ErrorPage
          title={i18n.t('errorPage.title')}
          message={i18n.t('errorPage.message')}
          fixingMessage={i18n.t('errorPage.fixingMessage')}
          reloadLabel={i18n.t('errorPage.reloadButton')}
          onReload={this.handleReload}
        />
      );
    }

    return this.props.children;
  }
}
